import { alpha, Box, Tooltip, Typography, useTheme } from "@mui/material";
import React from "react";

const isValidCssColor = (color) => {
    const s = new Option().style;
    s.color = color;
    return s.color !== "";
};

const CustomChip = ({ text, color = "primary", title = "Status", tooltipPlacement = "bottom", onClick = null, disabled = false }) => {
    const theme = useTheme();
    let bgColor, textColor;

    if (theme.palette[color]) {
        bgColor = alpha(theme.palette[color].light, 0.25);
        textColor = alpha(theme.palette[color].main, 1);
    } else if (isValidCssColor(color)) {
        bgColor = alpha(color, 0.25);
        textColor = color;
    } else {
        bgColor = alpha(theme.palette.primary.light, 0.25);
        textColor = theme.palette.primary.main;
    }

    return (
        <Tooltip title={`${title}: ${text}`} arrow placement={tooltipPlacement}>
            <Box
                onClick={!disabled && typeof onClick === "function" ? onClick : undefined}
                role={onClick && !disabled ? "button" : undefined}
                tabIndex={onClick && !disabled ? 0 : undefined}
                sx={{
                    background: bgColor,
                    cursor: onClick && !disabled ? "pointer" : "default",
                    pt: "2px",
                    px: "20px",
                    borderRadius: "20px",
                    userSelect: "none",
                }}>
                <Typography
                    variant="body1"
                    color={textColor}
                    fontWeight={"bold"}
                    sx={{ textWrap: "nowrap" }}
                    margin={0}>
                    {text}
                </Typography>
            </Box>
        </Tooltip>
    );
};

export default CustomChip;

